var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoMedicion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2385,
    height: 314,
    viewBox: "0 0 2385 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 2385,
    height: 314,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-270 -1579)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 270, 1579)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495,1642v-4a53,53,0,0,0-53-53H332a53,53,0,0,0-53,53v190a53,53,0,0,0,53,53H2593a53,53,0,0,0,53-53v-80a53,53,0,0,0-53-53H548A53,53,0,0,1,495,1642Z",
    transform: "translate(-270 -1579)",
    fill: "#a6d66b"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(382.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.9,
    y: 26
  }, "Flujo por"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.474,
    y: 54.8
  }, "gotero")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(568.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.869,
    y: 26
  }, "Distancia"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.195,
    y: 54.8
  }, "goteros")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(770.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.466,
    y: 26
  }, "Piqueta por "), /*#__PURE__*/React.createElement("tspan", {
    x: 34.724,
    y: 54.8
  }, "planta")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(966.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 25.918,
    y: 26
  }, "Cintas x"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.754,
    y: 54.8
  }, "cama")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1167.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.484,
    y: 26
  }, "Tiempo de"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.957,
    y: 54.8
  }, "riego min")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1368.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33.119,
    y: 26
  }, "No. de"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.414,
    y: 54.8
  }, "pulsos")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1559.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.779,
    y: 26
  }, "Tiempo x"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.693,
    y: 54.8
  }, "pulso")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1767.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.83,
    y: 26
  }, "Intervalo / "), /*#__PURE__*/React.createElement("tspan", {
    x: 34.414,
    y: 54.8
  }, "pulsos")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1968.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.508,
    y: 26
  }, "Vol\xFAmen x"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.724,
    y: 54.8
  }, "planta")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(2169.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.508,
    y: 26
  }, "Vol\xFAmen x"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.931,
    y: 54.8
  }, "HA (Lt)")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(2370.161 1734.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.906,
    y: 26
  }, "Recomendaci\xF3n "), /*#__PURE__*/React.createElement("tspan", {
    x: 64.783,
    y: 54.8
  }, "LT/ HA")), /*#__PURE__*/React.createElement("path", {
    d: "M353.217,1632.133l-.018-.023-19.062-24.6A1.319,1.319,0,0,0,333.1,1607h0a1.322,1.322,0,0,0-1.04.507l-19.146,24.469a1.169,1.169,0,0,0-.081.117,26.012,26.012,0,1,0,40.391.04Zm-20.211,39.83a23.435,23.435,0,0,1-18.026-38.333,1.351,1.351,0,0,0,.118-.169l17.99-22.992,17.987,23.21c.017.025.036.049.055.072a23.434,23.434,0,0,1-18.124,38.212Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.8,1643.973l0-.012a1.323,1.323,0,0,0-.865-.932,17.217,17.217,0,0,0-6.11-.6,19.273,19.273,0,0,0-12.417,5.825,19.561,19.561,0,0,0-5.42,9.65l-6.692-6.692a1.32,1.32,0,1,0-1.867,1.867l7.821,7.821a1.308,1.308,0,0,0,.307.228,17.014,17.014,0,0,0,.623,5.653,1.325,1.325,0,0,0,.838.837,16.411,16.411,0,0,0,4.774.644c.425,0,.872-.014,1.335-.047a19.28,19.28,0,0,0,12.418-5.824A18.888,18.888,0,0,0,353.8,1643.973Zm-7.126,16.553a16.527,16.527,0,0,1-10.623,5.049,16.339,16.339,0,0,1-2.924-.037l13.1-13.1a1.32,1.32,0,0,0-1.867-1.867l-13.1,13.1a17.4,17.4,0,0,1,15.635-18.6,15.972,15.972,0,0,1,4.532.29A16.3,16.3,0,0,1,346.675,1660.526Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.344,1664.1a17.86,17.86,0,0,1-5.008-3.571,16.3,16.3,0,0,1-4.753-15.163,16.285,16.285,0,0,1,13.988,3.683,1.321,1.321,0,0,0,1.711-2.012,18.625,18.625,0,0,0-17.2-4.005,1.323,1.323,0,0,0-.865.932l0,.012a18.887,18.887,0,0,0,5.259,18.421,20.446,20.446,0,0,0,5.752,4.092,1.3,1.3,0,0,0,.56.126,1.32,1.32,0,0,0,.563-2.515Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.389,1631.041a1.32,1.32,0,0,0,2.087-1.617l-7.585-9.788a1.32,1.32,0,0,0-2.087,1.617Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(382.161 1626.562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "Riego")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMedicion);
export default __webpack_public_path__ + "static/media/info-medicion.c7d2f1f76e5658455d34645a176848b5.svg";
export { ForwardRef as ReactComponent };